import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { filterMenuByPermissions } from 'services/menu/menuPermissionFilter'
import contractActions from 'redux/contracts/actions'
import CopyModal from 'pages/contracts/copy'
import styles from '../MenuPagesSetting/style.module.scss'

// Tools that open a dialog on the current page instead of navigating to a route.
const MODAL_ACTIONS = {
  copyProject: contractActions.OPEN_COPY_CONTRACT,
}

const mapStateToProps = ({ menu, user }) => ({
  menuTools: menu.menuTools,
  userPermissions: user.permissions || [],
})

@connect(mapStateToProps)
class MenuPagesTools extends React.Component {
  menu = () => {
    const { menuTools = [], userPermissions, dispatch } = this.props
    const filteredMenu = filterMenuByPermissions(menuTools, userPermissions)
    return (
      <Menu selectable={false} style={{ width: 200 }}>
        {filteredMenu.map(item => {
          if (MODAL_ACTIONS[item.key]) {
            return (
              <Menu.Item
                key={item.key}
                onClick={() => dispatch({ type: MODAL_ACTIONS[item.key] })}
              >
                <i className={`${item.icon} mr-2`} />
                <FormattedMessage id={item.key} />
              </Menu.Item>
            )
          }
          if (item.url) {
            return (
              <Menu.Item key={item.key}>
                <Link to={item.url}>
                  <i className={`${item.icon} mr-2`} />
                  <FormattedMessage id={item.key} />
                </Link>
              </Menu.Item>
            )
          }
          return null
        })}
      </Menu>
    )
  }

  render() {
    const { menuTools = [], userPermissions } = this.props
    // Hide the whole menu when the user cannot see any tool.
    if (filterMenuByPermissions(menuTools, userPermissions).length === 0) {
      return null
    }
    return (
      <>
        <Dropdown overlay={this.menu} trigger={['click']} placement="bottomLeft">
          <div className={styles.dropdown}>
            <i className={`${styles.icon} fe fe-tool`} />
            <span className="d-none d-lg-inline-block">
              <FormattedMessage id="tools" />
            </span>
          </div>
        </Dropdown>
        <CopyModal />
      </>
    )
  }
}

export default MenuPagesTools
